import { useState, useEffect } from "react";
import MainContainer from "../../components/app/maincontainer";
import Header from "../../components/partials/header";
import {
	AddDataModal,
	AddUsersModal,
} from "../../components/modals/addtoolsmodal";
import DataTable from "../../components/tables/data-table";
import { useParams, useNavigate } from "react-router-dom";
import { apiCall } from "../../data/useFetcher";
import { useRawdataStore } from "../../data/stores/loggerStore";
import { LoadMore, MainPaginate } from "../../components/app/buttons";
import RawSample from "../../assets/Tool Category Sample.xlsx";

const DataCategory = () => {
	const [tab, setTab] = useState("all data"),
		tabs = ["all data", "Newly uploaded data"],
		[modal, setModal] = useState(""),
		{ page } = useParams(),
		navigate = useNavigate();

	let { getLogger, getDynamicLogger }: any = useRawdataStore();

	useEffect(() => {
		apiCall({
			type: "get",
			url: `/api/v1/rawdata${tab !== tabs?.[0] ? `?streamline=week` : ""}`,
			getter: (d: any) =>
				tab !== tabs?.[0] ? getDynamicLogger(d, "recent") : getLogger(d),
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [tab]);

	return (
		<div>
			<MainContainer>
				<Header
					btn1Text={"Bulk Upload"}
					btn2Text={"Add New Data"}
					handleAdd={() => navigate("add-data")}
					handleModal={() => setModal("add")}
					text={page}
				/>
				<div className="mt-8 bg-white rounded-lg p-6">
					<div className="h-16 border-b border-b-[#E3E3E3] flex gap-4">
						{tabs?.map((t, i) => (
							<button
								key={i}
								onClick={() => setTab(t)}
								className={`h-full capitalize px-1 text-base ${
									tab === t
										? "font-medium border-b-4 text-[#111014] border-b-[#2658AB]"
										: "font-normal border-b-none text-[#878789]"
								}`}>
								{t}
							</button>
						))}
					</div>
					<MainSection tab={tab} tabs={tabs} />
				</div>
				{modal === "add" && (
					<AddUsersModal
						handleClose={() => setModal("")}
						title={"Upload new data list"}
						subtitle="Add new data"
						handleImport={pres => {
							navigate("add-data", { state: pres });
							setModal("");
						}}
						sample={RawSample}
					/>
				)}
				{modal === "new" && (
					<AddDataModal
						handleClose={() => setModal("")}
						title={"Upload new data"}
						subtitle="Add new data"
						// title="Update data list"
						// subtitle="Update data"
					/>
				)}
			</MainContainer>
		</div>
	);
};

export default DataCategory;

const MainSection = ({ tab, tabs }) => {
	let [datum, setDatum] = useState({ docs: [] }),
		{ getLogger, mainSearch, isFound, data, recent, getDynamicLogger }: any =
			useRawdataStore(),
		[loading, setLoading] = useState<string | boolean>(false);

	useEffect(() => {
		if (isFound) setDatum(mainSearch);
		else setDatum(tab === tabs?.[1] ? recent : data);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [data, isFound, mainSearch, tab, recent]);

	const handleLoadMore = async () => {
		setLoading("loadmore");
		await apiCall({
			type: "get",
			url: `/api/v1/rawdata?limit=${data?.limit * data?.nextPage}${
				tab !== tabs?.[0] ? `&streamline=week` : ""
			}`,
			getter: (d: any) =>
				tab !== tabs?.[0] ? getDynamicLogger(d, "recent") : getLogger(d),
		});
		setLoading(false);
	};

	const [itemOffset, setItemOffset] = useState(0);
	let [range] = useState(10);
	const endOffset = itemOffset + range;

	// if (!datum && !data) return <PageLoader />;
	if (!datum) return;

	const currentItems = datum?.docs?.slice(itemOffset, endOffset);
	const pageCount = Math.ceil(datum?.docs?.length / range);

	const handlePageClick = (event: any) => {
		const newOffset = (event.selected * range) % datum?.docs?.length;
		setItemOffset(newOffset);
	};

	return (
		<DataTableCenter
			currentItems={currentItems}
			pageCount={pageCount}
			datum={datum}
			handleLoadMore={handleLoadMore}
			loading={loading}
			handlePageClick={handlePageClick}
			usecase="data"
			setDatum={setDatum}
		/>
	);
};

export const DataTableCenter = ({
	currentItems,
	pageCount,
	datum,
	handleLoadMore,
	loading,
	handlePageClick,
	usecase,
	setDatum,
}) => {
	return (
		<>
			<DataTable
				data={currentItems}
				usecase={usecase}
				datum={datum}
				setDatum={setDatum}
			/>
			<div className="mt-10 flex justify-center w-44 items-center mx-auto">
				<LoadMore
					next={datum?.hasNextPage}
					loading={loading === "loadmore"}
					handleLoadMore={handleLoadMore}
				/>
			</div>
			{pageCount > 1 && (
				<MainPaginate pageCount={pageCount} handlePageClick={handlePageClick} />
			)}
		</>
	);
};